export default {
    ren: 'People',
    jiangong: 'Item, total',
    dingdanjine: 'Amount',
    bubaohandandu: 'This amount does not include the amount for separately purchased auxiliary products',
    shijizhifu: 'Summary Support',
    yincangquanbu: 'Hide All',
    zhankaiquanbu: 'Expand All',
    dingdanxiangqing: 'Order Details',
    yizhifu: 'Payment',
    caozuo: 'Operate',
    dingdanchuangjianshijian: 'Order Creation Date',
    ewaixingli: 'Purchase Extra Baggage',
    tianjiaxingli: 'Add Baggage Service',
    zanweigoumaifuyingchanpin: "I haven't purchased any auxiliary products yet",
    xinglixinxi: 'Luggage Information',
    buxuyao: 'No Need',
    suoyouchengke: 'All Passengers',
    weisuoyouchengkegoumai: 'Unified purchase for all passengers',
    weisuoyouchengkedandugoumai: 'Purchase separately for each passenger',
    qucheng: 'Outbound',
    huicheng: 'Return',
    fujiafuwu: 'Add On',
    xinglizonge: 'Total Price Of Luggage'
};